import './Pill.css';
import type { JSX, Ref } from 'preact';
import { Icon } from './Icon';
import type { IconName } from './icons';

type NativeAttrs = Omit<
  JSX.HTMLAttributes<HTMLButtonElement>,
  'class' | 'className' | 'children' | 'type' | 'onClick' | 'onToggle' | 'ref' | 'aria-pressed' | 'icon' | 'label'
>;

export interface PillProps extends NativeAttrs {
  /** Rótulo visível e nome acessível (ExteriorButton: fixo nos dois estados, X4 de §15.4.2). */
  label: string;
  icon: IconName;
  pressed: boolean;
  /** Recebe o próximo estado (`!pressed`). */
  onToggle?: (next: boolean) => void;
  /** Classes extras do dono. */
  class?: string;
  buttonRef?: Ref<HTMLButtonElement>;
}

/** Pílula de alternância (§3.8): `<button aria-pressed>`; oculta na TV (`.tv-hide`). */
export function Pill({ label, icon, pressed, onToggle, class: extra, buttonRef, ...rest }: PillProps) {
  return (
    <button
      {...rest}
      ref={buttonRef}
      type="button"
      class={`pill tv-hide${extra ? ` ${extra}` : ''}`}
      data-testid="pill"
      aria-pressed={pressed ? 'true' : 'false'}
      onClick={onToggle ? () => onToggle(!pressed) : undefined}
    >
      <span class="pill__icon">
        <Icon name={icon} size={13} />
      </span>
      <span class="pill__label">{label}</span>
    </button>
  );
}
